import { render, staticRenderFns } from "./EmpresaTabelaGestao.vue?vue&type=template&id=f6c028e0&lang=pug"
import script from "./EmpresaTabelaGestao.vue?vue&type=script&lang=js"
export * from "./EmpresaTabelaGestao.vue?vue&type=script&lang=js"
import style0 from "./EmpresaTabelaGestao.vue?vue&type=style&index=0&id=f6c028e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports